class Tabbedcontent {
    element = $('.js-tabbedcontent');
    items: any;
    topics: any;
  constructor() {
    $('.js-accessibility').hide();
    this.items = this.element.find('.js-item');
    let openItems;
    this.items.each((index, item) => {
        let items = $(item);
        let openItems = new TabbedItems(items);
    });

  }
}

class TabbedItems {
    element: any;
    content: any;
    constructor(items) {
        this.element = items;
        this.element.find('.js-content, ul, dd');
        this.element.on('mouseup', this.toggle.bind(this));
        this.element.removeClass('active');
    }
    toggle() {
        if(this.element.hasClass('active')) {
          this.element.removeClass('active');
        }else {
            $('.js-item.active').removeClass('active');
            this.element.addClass('active');
        }
    }
}

let tabbedcontent = new Tabbedcontent();
